export const SECURITY_FIELDS = {
    PASSWORD_EXPIRATION_DAYS: 'passwordExpirationDays',
    PASSWORD_EXPIRE_SOON_DAYS: 'passwordExpireSoonDays',
    MFA_STATUS: 'mfa.status',
    MFA_EMAIL_ENABLED: 'mfa.email.enabled',
    IP_WHITELIST_ENABLED: 'ipWhitelist.enabled',
    IP_WHITELIST_LIST: 'ipWhitelist.list',
    LIVE_HELP_CSP_WHITELIST_ENABLED: 'liveHelpCspWhitelist.enabled',
    LIVE_HELP_CSP_WHITELIST_LIST: 'liveHelpCspWhitelist.list',
    CSP_WHITELIST_ENABLED: 'cspWhitelist.enabled',
    CSP_WHITELIST_LIST: 'cspWhitelist.list'
};